import { useEffect } from 'react';
import { useUIStore } from '@/stores';

export function ThemeProvider({ children }: { readonly children: React.ReactNode }) {
  const theme = useUIStore((state) => state.theme);

  useEffect(() => {
    // Ensure theme is applied on mount
    const root = document.documentElement;
    root.classList.toggle('dark', theme === 'dark');
  }, [theme]);

  return <>{children}</>;
}
